import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    filterParamsMap = {
        account: 'account_id'
    },
    name = 'categoriesAwsSupport',
    exports = storeModuleFactory({
        name,
        filterParamsMap,
        timeout:  TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        endpoint: endpoints.categoriesAwsSupport.endpoint
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/categoriesAwsSupport.js